export const WorkflowButtonStates = {
    HIDE: "Hide",
    SHOW: "Show",
    ANIMATE_REMOVE: "AnimateRemove",
    CONFIRM: "Confirm",
    COMPLETE: "Complete",
    VISIBLE_COMPLETE: "VisibleComplete"  // display only state
};